import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ISA315RelateItProcessItAppListItem from './ISA315RelateItProcessItAppListItem';

function ISA315RelateItProcessItAppList({
	allIds,
	engagementId,
	bodyId,
	byId,
	relateEntityAction,
	entityColor,
	entityConfig,
	entityCount,
	entityName,
	entityProps,
	header,
	dragAndDrop,
	onClick,
	entityId,
	onRemove
}) {
	return (
		<StyledISA315RelateItProcessItAppList className="StyledISA315RelateItProcessItAppList customScrollbar">
			{allIds &&
				allIds.map((id) => (
					<ISA315RelateItProcessItAppListItem
						key={id}
						engagementId={Number(engagementId)}
						bodyId={bodyId}
						id={id}
						byId={byId}
						relateEntityAction={relateEntityAction}
						entityColor={entityColor}
						entityConfig={entityConfig}
						entityCount={entityCount}
						entityName={entityName}
						entityProps={entityProps}
						onRemove={onRemove}
						entityId={entityId}
						header={header}
						dragAndDrop={dragAndDrop}
						onClick={onClick}
					/>
				))}
		</StyledISA315RelateItProcessItAppList>
	);
}

ISA315RelateItProcessItAppList.propTypes = {
	engagementId: PropTypes.number.isRequired,
	bodyId: PropTypes.number.isRequired,
	allIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	byId: PropTypes.func.isRequired,
	entityColor: PropTypes.string,
	entityConfig: PropTypes.func.isRequired,
	entityCount: PropTypes.func.isRequired,
	entityName: PropTypes.func.isRequired,
	entityProps: PropTypes.func.isRequired,
	header: PropTypes.string.isRequired,
	dragAndDrop: PropTypes.bool,
	onClick: PropTypes.func.isRequired,
	entityId: PropTypes.number.isRequired,
	onRemove: PropTypes.func.isRequired
};

export default ISA315RelateItProcessItAppList;

const StyledISA315RelateItProcessItAppList = styled.section`
	max-height: calc(100% - var(--px-110));
	padding-right: var(--px-5);
`;
